/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, Typography, useTheme } from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';
import PieChartOutlineIcon from '@mui/icons-material/PieChartOutline';
import { CardV2 } from '../../../components/v2';
import { ChartEmpty, CHART_HEIGHT } from './chartShared';
import { STATUS_LABELS, SYNC_STATUS } from './constants';
// import DigitadorChart from './DigitadorChart';
// import MalhaChart from './MalhaChart';
// import VolumeTimelineChart from './VolumeTimelineChart';

const PieEmpty = ({ message }) => (
  <Box
    sx={{
      height: CHART_HEIGHT,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'text.secondary',
      gap: 1,
    }}
  >
    <PieChartOutlineIcon sx={{ fontSize: 40, opacity: 0.4 }} />
    <Typography variant="body2">{message}</Typography>
  </Box>
);

PieEmpty.propTypes = {
  message: PropTypes.string.isRequired,
};

const ChartsRow = ({ resumo, resumoLoading }) => {
  const theme = useTheme();
  const { filtrado } = resumo;

  const pieColors = [
    theme.palette.info.main,
    theme.palette.success.main,
    theme.palette.error.main,
  ];

  const pieData = useMemo(() => {
    const items = [
      {
        id: SYNC_STATUS.NOT_SYNC,
        value: filtrado[SYNC_STATUS.NOT_SYNC] ?? 0,
        label: STATUS_LABELS[SYNC_STATUS.NOT_SYNC],
      },
      {
        id: SYNC_STATUS.SYNCED,
        value: filtrado[SYNC_STATUS.SYNCED] ?? 0,
        label: STATUS_LABELS[SYNC_STATUS.SYNCED],
      },
      {
        id: SYNC_STATUS.ERROR_SYNC,
        value: filtrado[SYNC_STATUS.ERROR_SYNC] ?? 0,
        label: STATUS_LABELS[SYNC_STATUS.ERROR_SYNC],
      },
    ];
    return items.filter((item) => item.value > 0);
  }, [filtrado]);

  const pieHasData = pieData.length > 0;

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <CardV2 title="Distribuição por status">
          {resumoLoading ? (
            <PieEmpty message="Carregando…" />
          ) : pieHasData ? (
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
              <PieChart
                series={[
                  {
                    data: pieData,
                    innerRadius: 50,
                    paddingAngle: 2,
                    cornerRadius: 4,
                  },
                ]}
                colors={pieColors}
                height={CHART_HEIGHT}
                margin={{ right: 120 }}
                slotProps={{
                  legend: {
                    position: { vertical: 'middle', horizontal: 'right' },
                  },
                }}
              />
            </Box>
          ) : (
            <PieEmpty message="Sem dados no período selecionado" />
          )}
        </CardV2>
      </Grid>
      {/* Gráficos desabilitados até endpoints no servidor
      <Grid size={{ xs: 12, md: 8 }}>
        <VolumeTimelineChart apiFilter={apiFilter} refreshKey={refreshKey} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <DigitadorChart apiFilter={apiFilter} refreshKey={refreshKey} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <MalhaChart apiFilter={apiFilter} refreshKey={refreshKey} />
      </Grid>
      */}
    </Grid>
  );
};

ChartsRow.propTypes = {
  resumo: PropTypes.shape({
    filtrado: PropTypes.object,
  }).isRequired,
  resumoLoading: PropTypes.bool,
};

ChartsRow.defaultProps = {
  resumoLoading: false,
};

export default ChartsRow;
